import React from 'react';

function AddClassModal({
  showModal,
  handleModalClose,
  invitationCode,
  setInvitationCode,
  handleInvitationSubmit,
}) {
  // If modal shouldn't be displayed, return null
  if (!showModal) {
    return null;
  }

  return (
    // Modal backdrop & container
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Dark overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={handleModalClose}
      ></div>

      {/* Modal content */}
      <div className="relative w-full max-w-md mx-auto bg-[var(--card-bg)] text-[var(--text-color)] p-6 rounded-md shadow-lg transition-all transform">
        {/* Close (X) button */}
        <button
          onClick={handleModalClose}
          className="absolute top-4 right-4 text-xl font-bold text-[var(--text-color)] hover:text-[var(--primary-color)] transition-colors"
        >
          &times;
        </button>

        {/* Heading */}
        <h4 className="text-2xl font-bold mb-4">Enter Invitation Code</h4>

        {/* Input field */}
        <input
          type="text"
          id="invitation-code"
          className="w-full px-3 py-2 mb-4 border border-[var(--border-color)] rounded-md 
                     bg-[var(--input-bg)] text-[var(--text-color)]
                     focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] 
                     focus:border-transparent transition-all"
          placeholder="Invitation Code"
          required
          value={invitationCode}
          onChange={(e) => setInvitationCode(e.target.value.toUpperCase())}
        />

        {/* Submit button */}
        <button
          id="submit-invitation"
          className="w-full py-2 rounded-md font-semibold 
                     bg-[var(--primary-color)] text-white 
                     hover:bg-[var(--hover-color)] 
                     transition-colors disabled:opacity-60"
          onClick={handleInvitationSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default AddClassModal;
